export const API_CONFIG = {
  BASE_URL: 'http://localhost:3001/api/v1',
  TIMEOUT: 10000,
  ENDPOINTS: {
    // 认证相关
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      ADMIN_LOGIN: '/admin/login',
      ME: '/auth/profile',
      REFRESH: '/auth/refresh',
      VERIFY: '/auth/verify'
    },
    // 帖子相关
    POSTS: {
      LIST: '/posts',
      DETAIL: '/posts',
      CREATE: '/posts',
      UPDATE: '/posts',
      DELETE: '/posts',
      LIKE: '/posts',
      SHARE: '/posts',
      TRENDING: '/posts/trending'
    },
    // 评论相关
    COMMENTS: {
      LIST: '/comments/post',
      CREATE: '/comments/post',
      LIKE: '/comments',
      DELETE: '/comments',
      REPORT: '/comments'
    },
    // 文件上传
    UPLOAD: {
      SINGLE: '/upload/single',
      MULTIPLE: '/upload/multiple'
    },
    // 用户相关
    USERS: {
      LIST: '/users',
      DETAIL: '/users',
      SEARCH: '/users/search'
    },
    // 管理员相关
    ADMIN: {
      STATS: '/admin/stats',
      USERS: '/admin/users',
      POSTS: '/admin/posts',
      SETTINGS: '/admin/settings'
    }
  }
}

export default API_CONFIG